import { Column, IRowNode } from "@ag-grid-community/core";

export interface MaybernTableCellErrorParams<TData> {
  node: IRowNode<TData>;
  column?: Column;
  context: MaybernTableContextWithErrors<TData>;
}

export type MaybernTableGetErrorForCellFn<TData> = (
  params: MaybernTableCellErrorParams<TData>,
) => string | undefined;

export interface MaybernTableContextWithErrors<TData> {
  getErrorForCell?: MaybernTableGetErrorForCellFn<TData>;
}

export const getMaybernTableCellError = <TData>(
  params: MaybernTableCellErrorParams<TData>,
): string | undefined =>
  (
    params.context as MaybernTableContextWithErrors<TData> | undefined
  )?.getErrorForCell?.(params);
